export const MIXPANEL_TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN;

// event names
export const EVENT_NAMES = {
  FORM_SUBMITTED: 'Form Submitted',
  QUERY_EVENT: 'Query Event'
};
